import { render, staticRenderFns } from "./ServiceTodayNoCalling.vue?vue&type=template&id=5e3dd39e&scoped=true&"
import script from "./ServiceTodayNoCalling.vue?vue&type=script&lang=js&"
export * from "./ServiceTodayNoCalling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3dd39e",
  null
  
)

export default component.exports